// 客户 / 供应商的状态文案与颜色（文档 18 §4：5 色 + 灰；一行只一个实底标签）。
import type { TagTone } from '@/lib/status';

/** 启用是常态不打标签；停用给灰标签（老版「正常 / 停用」） */
export function activeState(isActive: boolean) {
  return isActive ? null : { label: '停用', tone: 'none' as TagTone };
}

/** 结算方式：次级信息用色点，不占实底标签 */
export function settlementText(p: { isMonthlySettlement: boolean; settlementDay?: number | null; paymentTermDays?: number | null }) {
  if (!p.isMonthlySettlement) return { label: '非月结', dot: 'grey' as const };
  const parts = ['月结'];
  if (p.settlementDay) parts.push(`每月 ${p.settlementDay} 日`);
  if (p.paymentTermDays != null) parts.push(`账期 ${p.paymentTermDays} 天`);
  return { label: parts.join(' · '), dot: 'amber' as const };
}

/** 客户资料完整度（老接口 profile 参数） */
export const customerProfile: Record<string, string> = {
  complete: '资料完整',
  missingContact: '缺联系人',
  missingPhone: '缺电话',
  missingAddress: '缺地址',
};

/** 发票类型（老系统 src/lib/labels.ts invoiceTypeLabels） */
export const invoiceType: Record<string, string> = {
  VAT_GENERAL: '普通发票',
  VAT_SPECIAL: '专用发票',
};

/** 采购单状态：待入库是等人动手（琥珀），部分入库是有未了事项（橙），已入库完成（绿），草稿 / 已取消灰 */
export const purchaseStatus: Record<string, { label: string; tone: TagTone }> = {
  DRAFT: { label: '草稿', tone: 'none' },
  ORDERED: { label: '待入库', tone: 'amber' },
  PARTIALLY_RECEIVED: { label: '部分入库', tone: 'orange' },
  RECEIVED: { label: '已入库', tone: 'green' },
  CANCELLED: { label: '已取消', tone: 'none' },
};

/** 报价历史来源（src/lib/quote-history.ts） */
export const quoteSource: Record<string, string> = {
  'product.create': '新建产品',
  'product.update': '修改产品',
  'product.save': '保存产品',
};
